import mainlogo from "../../assets/ClickHunts.png"
const Loader = () => {
  return (
    <>
        <img src={mainlogo} alt="clichunts loading screen" className='w-48 animate-fade'/>
    </>
  )
}

export default Loader